import styled from 'styled-components';
import { Destination } from '@/features/menu-availability/destination';
import { FindAlocation } from '@/features/menu-availability/find-a-location';
import { Conveyance } from '@/features/menu-availability/conveyance';
import { Stack } from '@/components/ui';
import { useSelector } from '@/redux';
import { getFontStyles } from '@/redux/cmsConfig/utils';
import { selectConveyance } from '@/redux/conveyanceMode/reducer';
import { Render } from '@/components/uielements/render';

export function MenuAvailability() {
  const { location } = useSelector(selectConveyance);

  return (
    <Container>
      <MenuWrapper>
        <Render
          condition={!location}
          whenTrue={
            <Stack align="center" position="center">
              <FindAlocation />
            </Stack>
          }
          whenFalse={
            <>
              <ConveyanceWrapper>
                <Conveyance />
              </ConveyanceWrapper>
              <DestinationWrapper>
                <Destination />
              </DestinationWrapper>
            </>
          }
        />
      </MenuWrapper>
    </Container>
  );
}

const MenuWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  @media only screen and (max-width: 767px) {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    gap: 4px;
  }
`;

const ConveyanceWrapper = styled.div`
  display: flex;
  align-items: center;
  width: auto;
`;

const DestinationWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 12px;
  min-width: 0;

  @media only screen and (max-width: 767px) {
    width: 100%;
    margin-top: -1px;
    margin-left: 0;
    padding-top: 0;
  }
`;

const Container = styled.div(({ theme }) => ({
  ...getFontStyles(theme.header.font, {
    font_size: (value) => {
      if (typeof value !== 'number') {
        return value;
      }

      if (value * 0.75 < 14) {
        return 14;
      }

      return value * 0.75;
    },
  }),
  maxWidth: '100%',

  // Mobile: the toggle row and the location pill span the header row (TEAM-13315 Figma).
  '@media (max-width: 767px)': {
    width: '100%',
  },

  '@media (min-width: 768px)': {
    ...getFontStyles(theme.header.font, ['font_size']),
  },
}));
